import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import styles from "../studioInfoModule.module.css";

function content(props) {
  return (
    <div>
      <h2 className={`${styles.title}`}>{props.data[0].title}</h2>
      <p className={`${styles.subValue}`}>
        <a className={`${styles.subValueLink}`} href={props.data[0].average_eft_value_link} target="_blank"
           rel="noopener noreferrer">
          {props.data[0].average_eft_value}
        </a>
      </p>
    </div>
  );
}

export default connect(state => ({
  data: state.studioInfo.membershipActivityTotals.data
}))(content);

content.propTypes = {
  data: PropTypes.array.isRequired
};
